import { requestGet, requestPost } from '@/utils/request';

const api = {
	LIST: '/member/user_list',
	OPTS: '/member/user_opts',
	ADD: '/member/user_add',
	ROLE_LIST: '/member/user_role_list',
	IS_EXIST_LOGIN_ACCOUNT: '/member/user_is_exist_login_account',
	SET_ENABLE: '/member/user_set_enable',
	SET_SPECIAL: '/member/user_set_special',
	DELETE: '/member/user_del',
	TOP_UP: '/member/user_top_up',
	CASH_OUT: '/member/user_cash_out',
	RESET_PASSWORD: '/member/user_reset_password',
};

export async function userList(queryParams) {
	return requestGet(api.LIST, queryParams);
}

export async function userOpts(queryParams) {
	return requestGet(api.OPTS, queryParams);
}

export async function userAdd(form) {
	return requestPost(api.ADD, form);
}

export async function userRoleList() {
	return requestGet(api.ROLE_LIST);
}

export async function userLoginAccountIsExist(loginAccount) {
	return requestGet(api.IS_EXIST_LOGIN_ACCOUNT, { val: loginAccount });
}

export async function userSetEnable(id, isEnable) {
	return requestPost(api.SET_ENABLE, { id, isEnable });
}

export async function userSetSpecial(id, isSpecial) {
	return requestPost(api.SET_SPECIAL, { id, isSpecial });
}

export async function userDel(id) {
	return requestPost(api.DELETE, { id });
}

export async function userTopUp(form) {
	return requestPost(api.TOP_UP, form);
}

export async function userCashOut(form) {
	return requestPost(api.CASH_OUT, form);
}

export async function userResetPassword(form) {
	return requestPost(api.RESET_PASSWORD, form);
}
